var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0C4.45312 0 4 0.453125 4 1V2.14062C2.28125 2.58984 1 4.14453 1 6V9.98438C1 9.98438 0.984375 10.2617 0.851563 10.5195C0.71875 10.7813 0.558594 11 0 11V12H10V11C9.40625 11 9.25391 10.7812 9.12891 10.5312C9.00391 10.2773 9 10.0039 9 10.0039V6C9 4.14453 7.71875 2.58984 6 2.14062V1C6 0.453125 5.54688 0 5 0ZM5 12C4.44922 12 4 12.4492 4 13C4 13.5508 4.44922 14 5 14C5.55078 14 6 13.5508 6 13C6 12.4492 5.55078 12 5 12ZM5 3C6.66406 3 8 4.33594 8 6V9.99609C8 9.99609 7.98828 10.4727 8.23438 10.9688C8.23828 10.9805 8.24609 10.9883 8.25 11H1.72656C1.73047 10.9922 1.73828 10.9844 1.74219 10.9805C1.99219 10.4883 2 10.0156 2 10.0156V6C2 4.33594 3.33594 3 5 3Z",
    fill: "#454A54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellIcon);
export default __webpack_public_path__ + "static/media/bell-icon.cb6fc74bb3b2a23be036ee2acfb8061d.svg";
export { ForwardRef as ReactComponent };